import { AxiosInstance } from 'axios';

export interface BlocklistEntry {
    id: number;
    company_id: number;
    email: string;
    created_at: string;
    updated_at: string;
}

export interface BlocklistResponse {
    count: number;
    blocklist: BlocklistEntry[];
}

export interface BulkOperationResponse {
    message: string;
    created?: number;
    duplicates?: number;
    failed?: number;
    deleted?: number;
    errors?: Array<{ email?: string; error: string }>;
}

export interface CheckBlockedResponse {
    company_id: number;
    email: string;
    is_blocked: boolean;
}

export interface FetchBlocklistParams {
    limit?: number;
    offset?: number;
    order?: string;
}

export class BlocklistService {
    constructor(private client: AxiosInstance) {}

    async fetchBlocklist(companyId: number, params: FetchBlocklistParams = {}): Promise<BlocklistResponse> {
        const { limit = 25, offset = 0, order = 'created_at:desc' } = params;
        const response = await this.client.get(`/companies/${companyId}/blocklist`, {
            params: { limit, offset, order }
        });
        return response.data;
    }

    async addEmail(companyId: number, email: string): Promise<BlocklistEntry> {
        const response = await this.client.post(`/companies/${companyId}/blocklist`, { email });
        return response.data;
    }

    async deleteEmail(companyId: number, id: number): Promise<void> {
        await this.client.delete(`/companies/${companyId}/blocklist/${id}`);
    }

    async bulkAddEmails(companyId: number, emails: string[]): Promise<BulkOperationResponse> {
        const response = await this.client.post(`/companies/${companyId}/blocklist/bulk`, { emails });
        return response.data;
    }

    async bulkDeleteEmails(companyId: number, ids: number[]): Promise<BulkOperationResponse> {
        const response = await this.client.delete(`/companies/${companyId}/blocklist/bulk`, {
            data: { ids }
        });
        return response.data;
    }

    async checkEmail(companyId: number, email: string): Promise<CheckBlockedResponse> {
        const response = await this.client.get(`/companies/${companyId}/blocklist/check`, {
            params: { email }
        });
        return response.data;
    }
}
